import { render, staticRenderFns } from "./precos-pesquisar.vue?vue&type=template&id=0b504d48&scoped=true&"
import script from "./precos-pesquisar.vue?vue&type=script&lang=js&"
export * from "./precos-pesquisar.vue?vue&type=script&lang=js&"
import style0 from "./precos-pesquisar.vue?vue&type=style&index=0&id=0b504d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b504d48",
  null
  
)

export default component.exports